<mat-form-field class="w-full" appearance="fill">
  <mat-label>{{ templateTag?.displayName }}</mat-label>
  <!-- <mat-icon matPrefix class="icon-size-5 text-theme-gray">search</mat-icon> -->
  <mat-icon *ngIf="dataUpcast?.value" matSuffix class="icon-size-5 text-theme-dark" (click)="clear()">clear</mat-icon>
  <input #searchInput type="text" matInput [formControl]="dataUpcast" />
</mat-form-field>
